export const SHOW_TOAST_MESSAGE_DURATION = 5000;
export const SHOW_SAVE_DATA_TOAST_DURATION = 1500;
export const SHOW_DEFAULT_TOAST_DURATION = 3000;
